import { User } from "@/types/user";
import { Avatar } from "@mui/material";

function stringToColor(string: string) {
  let hash = 0;
  let color = "#";
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ("00" + value.toString(16)).substr(-2);
  }
  return color;
}

export const UserAvatar = ({
  email,
  firstName,
  lastName,
  width,
  height, 
}: {
  email?: User["email"];
  firstName?: User["first_name"];
  lastName?: User["last_name"];
  width?: number,
  height?: number,
}) => {
  // TODO: Fill with profile picture if available, otherwise use initials
  const initials =
    firstName || lastName
      ? `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`
      : (email?.[0]?.toUpperCase() ?? "?");

  return (
    <Avatar
      sx={{
        width: width || 100,
        height: height || 100,
        bgcolor: email ? stringToColor(email) : "grey",
      }}
    >
      {initials}
    </Avatar>
  );
};
